import { render } from "./UserPostsDetailsView.vue?vue&type=template&id=e27abc48&scoped=true"
import script from "./UserPostsDetailsView.vue?vue&type=script&lang=js"
export * from "./UserPostsDetailsView.vue?vue&type=script&lang=js"

import "./UserPostsDetailsView.vue?vue&type=style&index=0&id=e27abc48&scoped=true&lang=css"

import exportComponent from "/Users/yangyu/go/go-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e27abc48"]])

export default __exports__